<template lang="pug">
  v-card.mb-3
    v-card-title.title(v-if="options.show_panel_title") {{extra.name}}
    template(v-if="msg")
      v-alert(type="success" :value="true") {{msg}}
    template(v-else)
      v-card-text
        v-layout(row wrap)
          template(v-if="user")
            v-flex(xs12 sm6): v-text-field(label="Vorname" v-model="user.vorname" disabled :error-messages="gqlErrorsFor('meineIdeeCreate', 'user')")
            v-flex(xs12 sm6): v-text-field(label="Nachname" v-model="user.nachname" disabled)
          template(v-else)
            v-flex(xs12 sm6): v-text-field(label="Vorname" v-model="edit.vorname" :error-messages="gqlErrorsFor('meineIdeeCreate', 'vorname')")
            v-flex(xs12 sm6): v-text-field(label="Nachname" v-model="edit.nachname" :error-messages="gqlErrorsFor('meineIdeeCreate', 'nachname')")
            v-flex(xs12 sm6): v-text-field(label="E-Mail" v-model="edit.email" :error-messages="gqlErrorsFor('meineIdeeCreate', 'email')")
          v-flex(xs12 sm6): v-autocomplete(label="Organisationseinheit" :items="projekte" v-model="edit.projektId" :error-messages="gqlErrorsFor('meineIdeeCreate', 'projekt_id')" item-text="name" item-value="id")
          v-flex(xs12): v-textarea(label="Freitext" auto-grow v-model="edit.freitext" :error-messages="gqlErrorsFor('meineIdeeCreate', 'freitext')")
      v-card-actions
        v-btn(@click="save" outline color="primary" :loading="loading > 0") Absenden

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import { user } from '../../router'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      user,
      loading: false,
      msg: null,
      edit: {
        vorname: '',
        nachname: '',
        email: '',
        projektId: null,
        freitext: '',
      }
    }
  },
  apollo: {
    projekte: gql`{ projekte(order: "name") { id name } }`
  },
  computed: {
    options() {
      return this.extra && this.extra.options || {}
    },
    signedIn() {
      return true
    },
  },
  methods: {
    save() {
      this.loading++
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation (
          $userId: ID
          $vorname: String
          $nachname: String
          $email: String
          $projektId: ID
          $freitext: String
        ) {
          meineIdeeCreate(
            userId: $userId
            vorname: $vorname
            nachname: $nachname
            email: $email
            projektId: $projektId
            freitext: $freitext
          ) {
            id
          }
        }`,
        variables: {
          ...this.edit,
          userId: user && user.id
        },
      }).then((data) => {
        this.loading--
        this.edit.vorname = ''
        this.edit.nachname = ''
        this.edit.email = ''
        this.edit.projektId = null
        this.edit.freitext = ''
        this.msg = 'Deine Idee wurde abgesendet'
      }).catch((error) => {
        this.gqlAddErrors(error)
        this.loading--
      })
    }
  }
}
</script>
